/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/**
 * 交易密码组件，可以放进弹出页或者普通页面
 */
import './index.scss';
import store from '@/store';
import DigitKeyboard from '@/packages/digit-keyboard';
import PasswordCells from '@/packages/password-cells';
import SmsCountdown from '@/shared/utils/SmsCountdown';
import SmsApi from '@/api/sms';
import TradeKeyApi from '@/api/tradeKey';

import { Button } from 'vant';
import { Toast, Dialog, DialogView } from '@hb/coffee';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { LivenessProjectEnum, LivenessSceneEnum } from '@/enums/liveness-param';
import { BasicAgreements } from '@/components/agreements';
import { ContractEnum } from '@/enums/contract-type';
import { setPageTitle } from '@/api/native/utils';
import URLUtils from '@/shared/utils/URLUtils';
import { livenessPop } from '../liveness-pop';
import { PWDAgreementData } from './pwd-agreement-data';

const { cityInfo } = store.state.base;
const area = (cityInfo as NativeModel.AliCityInfo).cityAdcode
  || (cityInfo as NativeModel.CityInfo).adCode
  || '';

@Component({ name: 'TradeKeyComponent' })
export default class TradeKeyComponent extends Vue {
  $refs!: {
    agrrementBar: BasicAgreements;
  };

  private password = '';

  private mode: 'set' | 'validate' | 'reset' = 'validate';

  private livenessOrderId?: string;

  private showSmsDialog = false;

  private smsCode = '';

  private smsCountDown = new SmsCountdown();

  private needBioPromise = Promise.resolve(false);

  private commodityId = '';

  private agreementDatas: PWDAgreementData = new PWDAgreementData();

  private h5Bio = Boolean(URLUtils.getQueryMap().h5Bio);

  // 获取页面显示的操作标题
  private get title(): string {
    return {
      set: '请设置交易密码，保障账户安全',
      reset: '请设置新的交易密码',
      validate: '请输入交易密码',
    }[this.mode];
  }

  public async init(commodityId: string): Promise<void> {
    this.commodityId = commodityId;
    this.password = '';
    this.showSmsDialog = false;
    this.mode = (await TradeKeyApi.isExsist()) ? 'validate' : 'set';
    this.agreementDatas.init(Number(this.commodityId), ContractEnum.PSW);

    if (this.mode === 'set') {
      try {
        // 5分钟内
        const { deviceInfo } = store.state.base;
        const needBio = await TradeKeyApi.needBioAuth({
          area,
          deviceNo:
            deviceInfo.idfa
            || deviceInfo.imei
            // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
            || deviceInfo.manufacturer + deviceInfo.deviceModel,
        });
        if (needBio) {
          this.livenessOrderId = await livenessPop.getOrderId({
            project: LivenessProjectEnum.ZYQ,
            scene: LivenessSceneEnum.SetPassword,
          });
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('e 交易密码组件 catch ', e);
        return Promise.reject(new Error('人脸识别未通过'));
      }
    }
    this.fixPageTitle();
    return Promise.resolve();
  }

  private fixPageTitle() {
    const actionName = this.mode === 'validate' ? '输入' : '设置';

    this.$ubtModuleExpose(
      `臻有钱_${actionName}交易密码页`,
      'commodityId',
      this.commodityId,
    );
    setPageTitle(`请${actionName}交易密码`);
  }

  @Watch('mode', { immediate: true })
  private modeChange() {
    this.fixPageTitle();
  }

  private get disableSubmit() {
    return this.password.length !== 6 || !this.agreementDatas.validated;
  }

  @Watch('password')
  private submitPswd(val: string) {
    if (val && val.length === 6) {
      if (this.mode === 'validate') {
        this.onSubmit();
      } else {
        this.onSetKey();
      }
    }
  }

  private async onSetKey() {
    const { deviceInfo } = store.state.base;
    this.$ubtPageButton(
      '臻有钱_设置交易密码页_下一步',
      'commodityId',
      this.commodityId,
    );

    try {
      await TradeKeyApi.set({
        tradeKey: this.password,
        area,
        deviceNo:
          deviceInfo.idfa
          || deviceInfo.imei
          // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
          || deviceInfo.manufacturer + deviceInfo.deviceModel,
        orderId: this.livenessOrderId,
      });

      this.password = '';
      this.mode = 'validate';

      this.$ubtPageButton('臻有钱_设置交易密码页_设置交易密码成功');
    } catch (e) {
      this.$ubtPageButton('臻有钱_设置交易密码页_设置交易密码失败');
    }
  }

  private onForgetKey() {
    this.$ubtPageButton('臻有钱_输入交易密码页_忘记密码');
    this.forgetKey();
  }

  private forgetKey() {
    const { deviceInfo } = store.state.base;

    this.smsCode = '';
    this.showSmsDialog = true;
    this.needBioPromise = TradeKeyApi.needBioAuth({
      area,
      deviceNo:
        deviceInfo.idfa
        || deviceInfo.imei
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        || deviceInfo.manufacturer + deviceInfo.deviceModel,
    });
  }

  private async onSendSms() {
    this.$ubtPageButton('臻有钱_重置密码_获取验证码');

    if (!this.smsCountDown.isRunning) {
      const sent = await SmsApi.sendReset();

      if (sent) {
        this.smsCountDown.start();
      } else {
        Toast('短信发送失败');
      }
    }
  }

  private async onSmsSubmit() {
    this.$ubtPageButton('臻有钱_重置密码_提交');

    if (!this.smsCode) {
      Toast.fail('请输入验证码');
      return false;
    }

    const validated = await SmsApi.check(`${this.smsCode}`);

    if (validated) {
      this.showSmsDialog = false;

      if (await this.needBioPromise) {
        this.livenessOrderId = await livenessPop.getOrderId({
          project: LivenessProjectEnum.ZYQ,
          scene: LivenessSceneEnum.ChangePassword,
          commodityId: this.commodityId,
        });
      }

      this.password = '';
      this.mode = 'reset';

      return true;
    }

    Toast('短信验证码不正确');
    return false;
  }

  private async onSubmit() {
    this.$ubtPageButton(
      '臻有钱_输入交易密码页_提交',
      'commodityId',
      this.commodityId,
    );

    const { token } = await TradeKeyApi.getToken(
      this.password,
      this.commodityId,
    );

    if (token) {
      this.$ubtPageButton(
        '臻有钱_输入交易密码页_提交成功',
        'commodityId',
        this.commodityId,
      );
      this.$emit('resolve', token);
    } else {
      Dialog.confirm({
        title: '交易密码不正确',
        cancelButtonText: '忘记密码',
        confirmButtonText: '重新输入',
        closeable: false,
        // 解决弹窗因zIndex太低被其他组件库的Popup覆盖的问题
        zIndex: 3000,
      })
        .then(() => {
          this.$ubtPageButton(
            '臻有钱_输入交易密码页_密码不正确重新输入',
            'commodityId',
            this.commodityId,
          );
          this.password = '';
        })
        .catch(() => {
          this.$ubtPageButton(
            '臻有钱_输入交易密码页_密码不正确忘记密码',
            'commodityId',
            this.commodityId,
          );

          this.forgetKey();
        });
    }
  }

  private onBlurFixed() {
    window.scrollTo(0, 0);
    document.body.scrollTop = document.body.scrollHeight;
  }

  private render() {
    return (
      <div class="TradeKeyComponent">
        <p v-class={['title']}>{this.title}</p>
        <PasswordCells v-class={['cells']} v-model={this.password} />

        <div class="TradeKeyComponent__agreementWrapper">
          <BasicAgreements
            ref="agrrementBar"
            onclickItem={(index: number) => this.agreementDatas.clickNormal(index)
            }
            status={this.agreementDatas}
          />
        </div>
        {this.mode === 'validate' && (
          <p
            v-class={['forgetTip']}
            class="VSimpleBtn"
            onClick={this.onForgetKey.bind(this)}
          >
            忘记密码
          </p>
        )}
        <DigitKeyboard v-model={this.password} maxLength={6} />

        <DialogView
          show={this.showSmsDialog}
          class="TradeKeyComponent__smsDialog"
          confirmButtonText="提交"
          title="重置密码"
          beforeClose={this.onSmsSubmit.bind(this)}
          on={{
            'update:show': (value: boolean) => {
              this.showSmsDialog = value;
            },
          }}
        >
          <div v-class={['dialogRow']}>
            <span v-class={['dialogRowLabel']}>手机号</span>
            <span>
              {store.state.base.originUserInfo.mobile
                && store.state.base.originUserInfo.mobile.replace(
                  /\d{4}$/,
                  '****',
                )}
            </span>
          </div>

          <div v-class={['dialogRow']}>
            <span v-class={['dialogRowLabel']}>验证码</span>
            <div v-class={['dialogRowInput']}>
              <input
                v-model={this.smsCode}
                pattern="[0-9]*"
                type="text"
                maxlength={4}
                onblur={() => this.onBlurFixed()}
                placeholder="输入验证码"
              />
              <Button
                size="small"
                type="plain"
                round
                disabled={this.smsCountDown.isRunning}
                onClick={this.onSendSms.bind(this)}
                v-class={['dialogSendBtn']}
              >
                {this.smsCountDown.text}
              </Button>
            </div>
          </div>
        </DialogView>
      </div>
    );
  }
}
